import React, { useState } from 'react'

import { Box, Button, Modal, Typography } from '@mui/material'

import BaseTextField from '../BaseTextField/BaseTextField'
import { styles } from './RichTextField.styles'
import './styles.css'

export const LINK_MODAL_TEST_ID = 'rich-text-field-link-modal'

interface IProps {
	closeModal: () => void
	label: string
	onChangeLabel: (e: React.ChangeEvent<HTMLInputElement>) => void
	onChangeUrl: (e: React.ChangeEvent<HTMLInputElement>) => void
	onRemoveLink: (e: React.MouseEvent<HTMLButtonElement>) => void
	onSaveLink: (e: React.MouseEvent<HTMLButtonElement>) => void
	open: boolean
	url: string
}

export function LinkModal(props: IProps) {
	const {
		url = '',
		label = '',
		onChangeUrl,
		onChangeLabel,
		onSaveLink,
		onRemoveLink,
		closeModal,
		...rest
	} = props

	const [urlValid, setUrlValid] = useState<boolean>(true)

	const handleInsertLink = (ev: React.MouseEvent<HTMLButtonElement>) => {
		if (!/^https?:\/\//.test(url)) {
			setUrlValid(false)
		} else {
			setUrlValid(true)
			onSaveLink(ev)
		}
	}

	return (
		<Modal
			{...rest}
			sx={{ borderRadius: '0.5rem', borderColor: 'transparent' }}
			onClose={closeModal}
			data-testid={LINK_MODAL_TEST_ID}
		>
			<Box
				sx={styles.linkModal}
				data-testid={`${LINK_MODAL_TEST_ID}__content`}
			>
				<Typography
					variant="body2"
					component="h2"
					color="text.input"
					sx={{ paddingLeft: '1rem', fontStyle: 'italic' }}
					data-testid={`${LINK_MODAL_TEST_ID}__url-heading`}
				>
					URL to hyperlink
				</Typography>
				<BaseTextField
					autoFocus
					value={url}
					onChange={onChangeUrl}
					placeholder="Enter link"
					variant="outlined"
					fullWidth
					error={!urlValid}
					helperText={!urlValid && 'Please enter a valid URL'}
					inputProps={{
						'data-testid': `${LINK_MODAL_TEST_ID}__url-input`,
					}}
				/>
				<Typography
					variant="body2"
					component="h2"
					color="text.input"
					sx={{
						paddingLeft: '1rem',
						marginTop: '2rem',
						fontStyle: 'italic',
					}}
					data-testid={`${LINK_MODAL_TEST_ID}__label-heading`}
				>
					Text to display
				</Typography>
				<BaseTextField
					autoFocus
					value={label}
					onChange={onChangeLabel}
					variant="outlined"
					fullWidth
					inputProps={{
						'data-testid': `${LINK_MODAL_TEST_ID}__label-input`,
					}}
				/>

				<Box mt={4} display="flex" justifyContent="center">
					<Button
						onClick={onRemoveLink}
						sx={{
							marginRight: '2rem',
							color: 'action.selected',
							textDecoration: 'underline',
						}}
						size="large"
						focusRipple
						data-testid={`${LINK_MODAL_TEST_ID}__cancel-btn`}
					>
						Cancel
					</Button>
					<Button
						onClick={handleInsertLink}
						variant="contained"
						sx={{ backgroundColor: 'action.selected' }}
						disabled={!url}
						size="large"
						focusRipple
						data-testid={`${LINK_MODAL_TEST_ID}__insert-link-btn`}
					>
						Insert Link
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}
